import { MouseState } from '../core/types'

export class InteractionManager {
  private mouse: MouseState = {
    x: 0,
    y: 0,
    normalizedX: 0,
    normalizedY: 0,
    isPressed: false
  }

  private listeners: Array<() => void> = []

  constructor(private element: HTMLElement) {
    this.setupEventListeners()
  }

  private setupEventListeners(): void {
    const updateFromPoint = (clientX: number, clientY: number) => {
      const rect = this.element.getBoundingClientRect()
      this.mouse.x = clientX - rect.left
      this.mouse.y = clientY - rect.top
      this.mouse.normalizedX = (this.mouse.x / rect.width) * 2 - 1
      this.mouse.normalizedY = -(this.mouse.y / rect.height) * 2 + 1
      // 速度ベクトルを簡易推定（最後の位置があれば）
      if (this.mouse.lastPosition) {
        const vx = this.mouse.x - this.mouse.lastPosition.x
        const vy = this.mouse.y - this.mouse.lastPosition.y
        this.mouse.velocity = { x: vx, y: vy }
      }
      this.mouse.lastPosition = { x: this.mouse.x, y: this.mouse.y }
    }

    const onMouseMove = (event: MouseEvent) => {
      updateFromPoint(event.clientX, event.clientY)
    }

    const onTouchMove = (event: TouchEvent) => {
      if (event.touches.length === 0) return
      const touch = event.touches[0]
      updateFromPoint(touch.clientX, touch.clientY)
    }

    const onMouseDown = () => { this.mouse.isPressed = true }
    const onMouseUp = () => { this.mouse.isPressed = false }

    // Pointer Events優先（ブラウザ互換でmouse/touchも併用）
    this.element.addEventListener('pointermove', onMouseMove as unknown as EventListener)
    this.element.addEventListener('mousemove', onMouseMove)
    this.element.addEventListener('touchmove', onTouchMove, { passive: true })
    this.element.addEventListener('mousedown', onMouseDown)
    this.element.addEventListener('mouseup', onMouseUp)
    this.element.addEventListener('touchstart', onMouseDown)
    this.element.addEventListener('touchend', onMouseUp)

    this.listeners.push(
      () => this.element.removeEventListener('pointermove', onMouseMove as unknown as EventListener),
      () => this.element.removeEventListener('mousemove', onMouseMove),
      () => this.element.removeEventListener('touchmove', onTouchMove),
      () => this.element.removeEventListener('mousedown', onMouseDown),
      () => this.element.removeEventListener('mouseup', onMouseUp),
      () => this.element.removeEventListener('touchstart', onMouseDown),
      () => this.element.removeEventListener('touchend', onMouseUp)
    )
  }

  getMouseState(): Readonly<MouseState> {
    return { ...this.mouse }
  }

  dispose(): void {
    this.listeners.forEach(removeListener => removeListener())
    this.listeners = []
  }
}